import React, { useEffect, useState } from 'react'
import "./SliderProductImageCard.css"
import { getProfilePictureByUserId } from '../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import { useAppDispatch } from '../../../../redux/store/store'
import { useTranslation } from 'react-i18next'
import { getMinimalUserInfoData, getS3ProductPhysicalImgUri, UserInfoCache, UserInfoCacheType } from '../../../../utils/staticVariables/staticVariables'
import LoadingSpinner from '../../../LoadingSpinner'
import { ProductImageDB, removeProductImagesReducer } from '../../../../redux/slices/components/ProductsImages/ProductsImagesSlice'
import { verifyProductImage } from '../../../../utils/requestsUtils/functionsRequests/products/productsFunctions'

type SliderProductCardProps = {
    product: ProductImageDB,
    index: number,
    lengthProduct: number
    editable: boolean
}

const SliderProductCard = ({ product, index, editable }: SliderProductCardProps) => {

    const { t, i18n } = useTranslation()
    const dispatch = useAppDispatch()

    const [profileImgeUrl, setProfileImgeUrl] = useState<string>("")
    const [showForm, setShowForm] = useState(false)
    const [userName, setUserName] = useState("")
    const [loading, setLoading] = useState(false)


    useEffect(() => {

        const getData = () => {
            const user = UserInfoCache.userNameCache.get(product.userId)

            if(user?.name){
                    setUserName(user.name)
                }else{
                getMinimalUserInfoData(product.userId)
                .then((userInfo: UserInfoCacheType) => {
                    UserInfoCache.addNameInfo(product.userId, { name: userInfo.name, phoneNumber: userInfo.phoneNumber, mail: userInfo.mail, gimmerScore: userInfo.gimmerScore, gimScore: userInfo.gimScore })
                    setUserName(userInfo.name)
                }).catch(() => {})
            }

            getProfilePictureByUserId(product.userId, "small")
            .then((url) => {
                setProfileImgeUrl(url)
            }).catch(() => {
    
            })
            
        }

        getData()

    }, [])

    const onPress = (approved: boolean) => {

        setLoading(true)
        verifyProductImage(product.id, approved)
        .then(() => {
            dispatch( removeProductImagesReducer(product.id) )
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })
    }


    return (
        <div id={`slider-product-${index.toString()}`} className="con-product-img-card p-relative" >

            <div className="card-product-img flex flex-d-column">

                <div className="flex flex-1">
                    
                    <div className="width-50 height-100">
                        {
                            product.typeProduct === "PHYSICAL" ? 
                            <img 
                                src={getS3ProductPhysicalImgUri(product.userId, product.id, "mid")}
                                alt="" 
                                style={{ width: "100%", height: "30vh", objectFit: "cover" }}
                            />
                            :
                            <div className="border-color-text-dashed center" style={{ width: "100%", height: "100%"}}>
                                <p className="fs-36-vh fw-700">{"File"}</p>
                            </div>
                        }
                    </div>

                    <div className="flex flex-d-column ml-10">
                        <p className="fs-14 mt-10">
                            {product.productName}
                        </p>

                        <p className="fs-14 mt-10">
                            {userName}
                        </p>
                        
                        <div className="flex flex-ai-center width-100 flex-jc-sb mt-20">

                            <button
                                className="btn-slider-card-product fs-11 invalid-btn pointer mr-6"
                                onClick={() => onPress(false)}
                            >
                                {t("General:label_057")}
                            </button>

                            <button
                                className="btn-slider-card-product fs-11 valid-btn pointer ml-6"
                                onClick={() => onPress(true)}
                            >
                                {t("General:label_056")}
                            </button>
                            
                        </div>
                    </div>

                </div>

                <div className="flex flex-ai-center mt-14" style={{ height: "8.5vh" }}>

                    <div className="flex width-50 pl-20">
                    </div>
                </div>

            </div>
            
            { loading && <LoadingSpinner fullPage={false} /> }
        </div>
    )
}

export default React.memo( SliderProductCard )